import { KitText } from '@omni/kit/components';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import Spacing from '@omni/kit/theming/Spacing';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export default function NotFoundScreen(): JSX.Element {
  const { t } = useTranslation(['common']);

  return (
    <View style={styles.fullScreen}>
      <View style={styles.container}>
        <KitText fontSize={32} bold center black>
          {t('common:pageNotFound')}
        </KitText>
        <KitText fontSize={18} gray center style={styles.description}>
          {t('common:pageNotFoundDescription')}
        </KitText>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  fullScreen: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    maxWidth: 620,
    paddingHorizontal: Spacing.l,
  },
  description: {
    marginTop: Spacing.m,
  },
});
